import { Alert } from '@mui/material'

import { useErrorContext } from './useErrorMessage'

interface ErrorPropUpProps {
    style?: string
}
const ErrorPopUp = ({ style }: ErrorPropUpProps) => {
    const { errorMessage, hideError } = useErrorContext()

    if (!errorMessage) return null

    if (errorMessage) {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        })
    }

    return (
        <Alert className={style} data-test="error-message" onClose={hideError} severity={'error'}>
            {`${errorMessage}`}
        </Alert>
    )
}

export default ErrorPopUp
